import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const BioMetricsIntegration = ({ location }) => {
  const pageTitle = `Best ERP Software ${location} | ERP Systems | Business Management Solutions - Tejaxo Software`;
  const metaDesc = `Tejaxo Software is a High Rated Indian ERP and BI software development company ${location}, providing award-winning Enterprise Resource Planning (ERP) software, business management solutions, services, and support.`;
  const metaKey = `Tejaxo Software, Tejaxo ERP, ERP Software ${location}, Tejaxo BI, School ERP ${location}, School Software ${location}`;

  //React.useEffect(() => {
  //  document.title = pageTitle;
  //  document.querySelector('meta[name="description"]').setAttribute('content', metaDesc);
  //  document.querySelector('meta[name="keywords"]').setAttribute('content', metaKey);
  //}, [pageTitle, metaDesc, metaKey]);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
    <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row">
          <h2 className="mkdf-page-title entry-title">Bio-Metrics Integration</h2>
        </div>
        <br />
        <div className="row">
          <div className="wpb_wrapper">
            <div style={{ display: 'none' }}></div>
            <p><strong>Bio-Metrics Integration</strong></p>
            <p>
              Tejaxo�s Bio-metrics helps you automate the time and attendance solutions. Schools can now
              track the attendance of the employees and students with the most advanced time tracking
              Bio-metrics. It helps you achieve convenience and security at the same time. The Fingerprint
              or the RFID card authenticates every individual entering the school. It helps you track the
              total time of students and staff in the school.
            </p>
            <p>
              Tejaxo Bio-metrics offers you time and attendance software with a bio-metric employee time clock.
              The timekeeper enables employees to check-in and out easily.
            </p>
            <p>Some more features of Tejaxo�s Biometrics are:</p>
            <ul>
              <li><strong>Integration with School management</strong> Software ensures minimum human effort and easy access to all data.</li>
              <li><strong>Authorize</strong> users as administrators.</li>
              <li><strong>Manager level access</strong> allows the head of the school to edit time cards, print reports, and manage the team.</li>
              <li><strong>Administrator level access</strong> offers the head of the school to manage the entire database.</li>
              <li><strong>Track Employee Time</strong> with the most advanced Bio-metrics. It includes arrival, departure, lunch breaks, Overtime, and many more.</li>
              <li><strong>Establish a management rule</strong> on how employee time is accounted for.</li>
              <li><strong>Manage adjustments</strong> by authorizing specific staff.</li>
              <li><strong>Generate professional reports</strong> about each data.</li>
              <li><strong>Calculate Total working Hours</strong> of the employees and supervisors.</li>
              <li><strong>Auto send emails</strong> and SMS to the employees.</li>
              <li><strong>Create employee early out report</strong> to track contribution of all the employees.</li>
              <li><strong>Calculate Overtime</strong> by generating a report of the extra hours.</li>
            </ul>
            <p><strong>Benefits of Tejaxo�s Bio-metrics</strong></p>
            <ul>
              <li>Increased processing speed</li>
              <li>Flexible</li>
              <li>Automates the payroll</li>
              <li>Eliminate all the hassle</li>
              <li>Eliminates time cards</li>
              <li>No chance early punch-ins</li>
              <li>Eliminates hours in payroll management</li>
              <li>Increases profitability</li>
            </ul>
          </div>
        </div>
      </div>
            </section>
        </MasterPage>
  );
};

export default BioMetricsIntegration;
